import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/ticketing`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchTickets = async (params, forcestats) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  if (!["my", "team", "creador", "centralizer"].includes(query.get("mode"))) {
    return null;
  }
  if (forcestats) {
    query.set("forcestats", "true");
  }
  query.set("pin", "true");

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const downloadTickets = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  if (!["my", "team", "creador"].includes(query.get("mode"))) {
    return null;
  }

  const res = await fetch(readUrl(`export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  const blob = await res.blob();
  return blob;
};

export const fetchTicket = async (itemId, params, forcestats) => {
  const auth = `Bearer ${getToken()}`;

  // aca agrego las querys para obtener del back el orden de los tickets filtrados.
  const query = params ? new URLSearchParams(params) : null;
  if (query && !["my", "team", "creador", "centralizer"].includes(query.get("mode"))) {
    return null;
  }
  if (query && forcestats) {
    query.set("forcestats", "true");
  }
  // eslint-disable-next-line no-unused-expressions
  query ? query.set("pin", "true") : null;

  // acá se valida si hay params para filtarar tickets o solo se busca un ticket
  let res = params
    ? await fetch(readUrl(`${itemId}?${query.toString()}`), {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
    : await fetch(readUrl(`${itemId}`), {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: auth,
          "Content-Type": "application/json",
        },
      });
  res = await parseJSON(res);
  return res.success;
};

export const fetchPiAsignable = async (itemId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(itemId ? `pi_asignable/${itemId}` : `pi_asignable`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchPiDerivadores = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`pi_derivadores`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchTicketing = async (itemId, ticket) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(ticket),
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchTicketingCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("categories"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const postTicketing = async (ticket) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(ticket),
  });

  res = await parseJSON(res);

  return res.success;
};

export const postTicketingOnBehalf = async (ticket) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`onbehalf`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(ticket),
  });

  res = await parseJSON(res);

  return res.success;
};

export const createWatcher = async (ticketId, watcher) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`watchers/${ticketId}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(watcher),
  });

  res = await parseJSON(res);

  return res.success;
};
